<template>
    <v-alert
        v-if="banner"
        class="ma-2 py-1"
        :type="banner.type || 'success'"
        :icon="banner.icon || false"
        variant="flat"
        :color="banner.color || 'primary'"
        closable
    >
        <template #text> <strong>Ihre nächste Aktion: </strong>{{ banner.text }} </template>
    </v-alert>
</template>

<script lang="ts">
import { Gesuch, GesuchStatus } from '@/models/Gesuch'
import type { IconValue } from 'vuetify/lib/composables/icons.mjs'

type BannerType = 'error' | 'success' | 'warning' | 'info' | undefined

const STATUS_MAP = {
    [GesuchStatus.NEW]: {
        color: 'action',
        type: 'success' as BannerType,
        icon: false as IconValue | false,
        text: 'Gesuch ausfüllen → Gesuch einreichen (zwingend vor Umsetzung)',
    },
    [GesuchStatus.READY_FOR_SUBMIT]: {
        color: 'action',
        type: 'success' as BannerType,
        icon: false as IconValue | false,
        text: 'Gesuch einreichen',
    },
    [GesuchStatus.AB_READY_FOR_SUBMIT]: {
        color: 'action',
        type: 'success' as BannerType,
        icon: false as IconValue | false,
        text: 'Projektabschluss einreichen',
    },
    [GesuchStatus.APPROVED]: {
        color: 'action',
        type: 'success' as BannerType,
        icon: false as IconValue | false,
        text: 'Kontoinformation ergänzen → fehlende Angaben ergänzen → alle Angaben überprüfen → Projektabschluss einreichen',
    },
    [GesuchStatus.INCOMPLETE]: {
        color: 'action',
        type: 'success' as BannerType,
        icon: false as IconValue | false,
        text: 'fehlende Angaben ergänzen → Gesuch erneut einreichen',
    },
    [GesuchStatus.AB_INCOMPLETE]: {
        color: 'action',
        type: 'success' as BannerType,
        icon: false as IconValue | false,
        text: 'fehlende Angaben ergänzen → Projektabschluss erneut einreichen',
    },
    [GesuchStatus.AB_APPROVED]: null,
    [GesuchStatus.AB_CANCELED]: null,
    [GesuchStatus.AB_IN_PROGRESS]: null,
    [GesuchStatus.AB_REJECTED]: null,
    [GesuchStatus.AB_SUBMIT]: null,
    [GesuchStatus.CANCELED]: null,
    [GesuchStatus.CLOSED]: null,
    [GesuchStatus.IN_PROGRESS]: null,
    [GesuchStatus.REJECTED]: null,
    [GesuchStatus.SUBMIT]: null,
}

export default {
    props: {
        gesuch: {
            type: Gesuch,
            required: true,
        },
    },
    data: function () {
        return {}
    },
    computed: {
        banner() {
            return this.mapStatus(this.gesuch.status)
        },
    },

    methods: {
        mapStatus(status: GesuchStatus | null) {
            if (status) {
                return STATUS_MAP[status]
            }
            return null
        },
    },
}
</script>
